import { Stack } from "@mui/material";
import { Edit, Labeled, ReferenceField, SimpleForm, Toolbar } from "react-admin";
import DeleteConfirmButton from "shared/components/dialogs/confirm/DeleteConfirmButton";
import SaveConfirmButton from "shared/components/dialogs/confirm/SaveConfirmButton";
import CustomDateInput from "shared/components/inputs/CustomDateInput";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { transformDatesToMidnight } from "../helpers";
import { validateEditForm } from "../validations";

export const GroupsSitesEdit = () => {
  return (
    <Edit>
      <SimpleForm toolbar={<CustomToolbar />} validate={validateEditForm} mode="onBlur">
        <Stack direction="column" gap={2} width="100%">
          <Stack direction="row" gap={4}>
            <Labeled source="group_id">
              <ReferenceField source="group_id" reference={SiteResourcesEnum.Groups} />
            </Labeled>
            <Labeled source="site_id">
              <ReferenceField source="site_id" reference={SiteResourcesEnum.Sites} />
            </Labeled>
          </Stack>
          <Stack direction="row" gap={2}>
            <CustomDateInput source="start_date" />
            <CustomDateInput source="end_date" />
          </Stack>
        </Stack>
      </SimpleForm>
    </Edit>
  );
};

const CustomToolbar = () => {
  return (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <SaveConfirmButton transformData={transformDatesToMidnight} />
      <DeleteConfirmButton />
    </Toolbar>
  );
};
